import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { LoginRequest } from 'src/main/webapp/assets/models/login.request';
import { ResetPasswordRQ } from 'src/main/webapp/assets/models/reset.password';
import { LoginService } from '../../services/login/login.service';
import { ResetPasswordService } from '../../services/reset-password/reset-password.service';
import { LocalStorageService } from '../../services/utils/localstorage.service';
import { MatchPasswordValidator } from '../../validators/matchpassword.validator';

/**
 * Componente per inserire la nuova password (a seguito di una richiesta di reset)
 */
@Component({
  selector: 'app-reset-password',
  styleUrls: ['./reset-password.component.scss'],
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {

  public errorMessage!: string | null;
  public resetPasswordForm: FormGroup;
  public resetPasswordToken!: string;

  constructor(
    private readonly logger: NGXLogger,

    private readonly resetPasswordService: ResetPasswordService,
    private readonly loginService: LoginService,
    private readonly localStorageService: LocalStorageService,

    private readonly matchPasswordValidator: MatchPasswordValidator,
    private readonly formBuilder: FormBuilder,
    public readonly activatedRoute: ActivatedRoute,
    private readonly router: Router
  ) {

    this.resetPasswordForm = this.formBuilder.group(
      {
        emailAddress: ['', Validators.required],
        password: ['', Validators.required],
        retypePassword: ['', Validators.required]
      },
      { validators: this.matchPasswordValidator.matchPassword }
    );
  }

  public ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      //riprendi il token dalla chiamata
      this.resetPasswordToken = params?.resetpasswordtoken as string;
    });
  }

  public sendResetPasswordRequest() {
    const formValue = this.resetPasswordForm.value as {
      emailAddress: string;
      password: string;
    };

    const email = formValue.emailAddress;
    const password = formValue.password;

    const resetPasswordRequest: ResetPasswordRQ = {
      emailAddress: email,
      newPassword: password,
      resetPasswordToken: this.resetPasswordToken
    };

    this.resetPasswordService.resetPassword(resetPasswordRequest).subscribe(
      (resetPasswordResponse: HttpResponse<any>) => {
        this.logger.info(`Reset status: ${resetPasswordResponse.status}, procedo al login`);

        this.loginService.login(new LoginRequest(email, password)).subscribe(
          (loginResponse: HttpResponse<any>) => {
            this.logger.info(`Login completato`);

            this.localStorageService.storeItem(
              LocalStorageService.TOKEN_KEY, loginResponse.body as string);

            //TODO per ora redireziono all'itinerario di test
            this.router.navigateByUrl('/bookID/test');
          },

          (loginError: HttpErrorResponse) => {
            this.logger.error('Errore durante il login');
            this.errorMessage = `LOGIN.ERRORS.${loginError.status}`;
          });
      },

      (resetPasswordError: HttpErrorResponse) => {
        this.logger.error(`Errore ${resetPasswordError.status} durante il reset password`);
        this.errorMessage = `RESET-PASSWORD.ERRORS.${resetPasswordError.status}`;
      });
  }

}
